import type { FeedbackStarDisplayMode } from './FeedbackStarIcon.styles';
import {
  FEEDBACK_STAR_COUNT,
  FEEDBACK_STAR_GREEN_FROM,
} from './feedbackStarRating.constants';

/**
 * Normalizes API `starRating` to a display level in `0..FEEDBACK_STAR_COUNT` (0 = none / empty row).
 */
export function getFeedbackStarDisplayLevelFromApi(
  starRating: number | null | undefined
): number {
  if (starRating == null || !Number.isFinite(starRating) || starRating < 1) {
    return 0;
  }
  return Math.min(FEEDBACK_STAR_COUNT, Math.floor(starRating));
}

/**
 * Fill mode for one star at `starIndex` (1-based), given the row’s effective `displayLevel`
 * (hover or committed value in the control; clamped API value in the list).
 */
export function getFeedbackStarIconDisplayMode(
  starIndex: number,
  displayLevel: number
): FeedbackStarDisplayMode {
  if (!Number.isFinite(displayLevel)) {
    return 'empty';
  }
  if (starIndex > displayLevel) {
    return 'empty';
  }
  return displayLevel >= FEEDBACK_STAR_GREEN_FROM ? 'green' : 'gold';
}
